module.exports = __webpack_public_path__ + "static/media/apple.4a6149cc.png";